import { all, takeLatest } from 'redux-saga/effects'
import * as actions from './telegramChatList.actions'
import { fetchGetTelegramChatListSaga } from './sagas/fetch-get-telegram-chat-list'

export default function* () {
  yield all([takeLatest(actions.FETCH_GET_TELEGRAM_CHAT_LIST_REQUEST, fetchGetTelegramChatListSaga)])
}
